import { render, staticRenderFns } from "./CarouselFeatured.vue?vue&type=template&id=0eb1b806&scoped=true&"
import script from "./CarouselFeatured.vue?vue&type=script&lang=js&"
export * from "./CarouselFeatured.vue?vue&type=script&lang=js&"
import style0 from "./CarouselFeatured.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CarouselFeatured.vue?vue&type=style&index=1&id=0eb1b806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb1b806",
  null
  
)

export default component.exports